import NationalityModel from '../Apis/Nationality'
import Controller from './Controller'

export default class NationalityController extends Controller {
  constructor() {
    super(new NationalityModel())
  }
}
